import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./components/styles.css";
import AboutHeader from "./layout/AboutHeader";
import Header from "./layout/header";
//import PartnerView from "./partner.view";
//import FeedbackView from "./feedback.view";
import Footer from "./layout/footer";
import osimg from '../images/OS 1.png'
import eyeQ from '../images/eyeQ.png'
import arrowImg from '../images/arrowImg.png'
import "./about.view.css";
import Feedbackspearte from "../pages/Feedbackspearte";
import { Link } from "react-router-dom";
import topImageQ from '../images/AboutImgQ.png'
import { useMediaQuery } from 'react-responsive';
import PartnerView from '../../src/pages/partner.view'
import FeedbackView from "./feedback.view";
import { Helmet } from 'react-helmet';
import MetaTag from "../component/Common/MetaTag.tsx";

const Qimage = "/assets/images/partnerlogo/Q.png";
//const topImage = "https://t4.ftcdn.net/jpg/02/07/15/43/360_F_207154340_wLIJus4m3SBl5sAQmpqN3Um7REnUhskU.jpg";

export default function About(props) {

  const styleFeedback = {
    backgroundColor: "white"
  }
  const imageSize = {
    width: '135px', height: '120px',
    objectFit: 'contain'
  }
  const settings = {
    dots: true,
    infinite: true,
    arrows: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };


  const underLine = {
    width: '130px',
    height: '3px',
    top: '5521px',
    left: '8553px',



  }
  const textHeader = {
    marginLeft: '170px',
    marginRight: '170px',

  }

  const isBigScreen = useMediaQuery({ query: '(min-width: 769px)' });
  const isTablet = useMediaQuery({ query: '(min-width: 481px) and (max-width: 768px)' });
  const isMobile = useMediaQuery({ query: '(max-width: 480px)' });

  return (
    <div className="overflow-hidden">
      <MetaTag
      // title="Unveiling Our Story, Mission, and Values | Q Academy"
      // description="Learn about our journey, mission, and values. Join us on a mission to provide the best online learning experience. Discover more about our story today!"
      // keywords="about q academy"
      />
      <Header />
      {//<AboutHeader />
      }
      <main style={{ marginBottom: '-44px', marginTop: '-56px' }}>
        {isBigScreen &&
          <section class="">
            <section className="position-relative element-style overflow-hidden pt-5 pt-lg-3 AboutBanner" >
              <div className="container"  >
                <div className="row align-items-center ">
                  <div className="col-lg-5 col-xl-6 position-relative z-index-1 text-center text-lg-start mb-sm-0 mt-50 align-middle" style={{ marginTop: '11rem', }}>
                    <h1 className="" style={{ fontWeight: 500, fontFamily: 'Roboto' }}>
                      About Us
                      <span className="position-relative">
                        &nbsp;
                        {/* SVG START */}
                        <span className="position-absolute top-50 start-50 translate-middle ms-3 z-index-n1 d-none">
                          <svg
                            width="300px"
                            height="62.1px"
                            enableBackground="new 0 0 366 62.1"
                            viewBox="0 0 366 62.1"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              className="fill-warning"
                              d="m322.5 25.3c0 1.4 2.9 0.8 3.1 1.6 0.8 1.1-1.1 1.3-0.6 2.4 13.3 0.9 26.9 1.7 40.2 4-2.5 0.7-4.9 1.6-7.3 1.1-4-0.9-8.2-1-12.2-1.2-8.5-0.5-16.9-1.9-25.5-1.7h-3.1c2.6 0.6 4.8 0.4 5.7 2.2-7.3 0.4-14.1-0.8-21.2-1.1-0.2 0.6-0.5 1.2-0.8 1.8 21.3 0.7 42.5 1.6 64.3 4.6-4.2 1.6-7.7 1-10.8 0.8-6.8-0.5-13.5-1.3-20.3-1.9-0.9-0.1-2.3-0.1-2.9 0.2-2.2 1.6-4.3 0.6-7 0.4 1.4-1 2.5 0.5 3.9-0.8-5.6-1-10.7 0.6-15.9 0s-10.5-0.6-16.6-0.8c2 1.6 4.6 1.3 6.2 1.4 4.9 0 9.9 0.8 14.8 0.7 5.3-0.1 10.4 0.5 15.5 0.9 3.2 0.3 6.7-0.1 9.9-0.4 1.1-0.1 0.5 0.3 0.6 0.6 0.5 0.9 2.2 0.8 3.6 0.8 5.1-0.1 10.1 0.6 14.8 1.5 0.8 0.1 1.5 0 1.7 0.7 0 0.7-0.8 0.6-1.5 0.8-3.9 1.2-7.4-0.2-11.1-0.2-2 0-4.3-1.5-6 0.5-0.3 0.4-1.4 0.1-2.2-0.1-4.5-0.8-9.1-0.5-13.8-1.5-2.3-0.5-5.6 0.1-8.4 0.5-4 0.5-8-0.7-12.1-0.9-3.4-0.2-7.1-0.5-10.5-0.7-7.1-0.3-14.2-1.2-22.3-0.4 4.9 1.1 9.4 1.2 13.8 1.2 9.7 0 19.2 2.3 28.9 1.6 7.3 3.2 15.9 1.5 23.8 2.9 4.9 0.8 10.1 0.8 15.2 1.2 0.5 0 0.8 0.3 1.1 0.9-20-2.1-40.2-1.4-60.8-3 4.9 2.1 10.8-0.3 15.3 2.7-8 1.9-15.8-0.9-23.5-0.1 2.8 1.4 7.1 1.1 9.3 3.3 0.5 0.5 0.2 1.1-1.2 1.3 2.3 1 3.4-2.1 5.7-0.4 0.2-0.6 0.2-1 0.3-1.5 0.8-0.3 2 0.8 1.5 1.5-0.2 0.1 0 0.3 0 0.5 18.7 0.4 37.3 1.7 56.2 3.6-1.7 1.1-2.8 1.2-4.2 1.1-7.1-0.5-14.1-0.9-21.2-1.4-3.1-0.2-6.3-0.4-9.4-0.4-7.6-0.2-15-0.7-22.4-1-9-0.4-17.9-0.1-26.9-0.1-1.2 0-2.9-0.4-3.9 1 14.8 0.3 29.7 0.6 44.4 1.1 14.8 0.6 29.9 1.3 44.2 4.2-4.3 1-8.8 0.9-13 0.5-5.3-0.5-10.5-1.1-15.8-1.2-11.4-0.3-22.9-0.9-34.3-1.2-17.6-0.4-35.4-0.3-53.1-0.4-10.8-0.1-21.7-0.2-32.5 0-17.8 0.4-35.7 0.2-53.5 0.5-13.1 0.3-26.3 0.1-39.4 0.5-11.1 0.3-22.4 0.6-33.6 1-13.1 0.6-26.1 0.2-39.3 0.4-3.9 0.1-7.6 0.2-11.8-0.2 0.9-1.2 2.3-1.3 3.9-1.3 8.4 0.2 16.6-0.4 24.9-0.9 3.9-0.2 7.9-0.4 11.9 0.2 2.5 0.4 5.3-0.3 8-0.4 7.3-0.4 14.7-0.7 22-0.9 11.9-0.5 23.7-1.2 35.6-0.8 7.7 0.2 15.3-0.6 22.9-0.1 2.3 0.2 4.3-0.5 6.5-1h-17.6c-9.6 0-19-0.1-28.6 0-8 0.1-16.1 0.3-24 0.8-2.6 0.2-5.4 0.1-8.2 0.1-10.1 0.3-20.1 0.6-30.2 0.5-5.4 0-10.7-0.1-15.9 0.6-2.3 0.3-4-1.3-6.5-0.6 0.2 0.4 0.5 0.9 0.6 1.5-1.9 0-4 0.4-4.9-0.1-4.2-2.2-9.4-1.5-14.1-2.3-1.7-0.3-3.7-0.1-4.3-1.5-0.5-1.3 1.9-1.5 2.6-2.6-4.2-1.4-4.6-5-8.5-7.2-1.5 0.2-0.9 2.8-4.2 1.3 0.3 2.4 4.5 3.9 2.8 6.4-2.3 0.3-3.2-0.8-4.2-1.7-2.5-4-5.1-8.4-5.1-12.7 0.2-6.8 0.2-13.8 3.6-20.4 0.3-0.5 0.3-1 0.8-1.4 0.9-0.9 1.2-2.4 3.6-2.1 2.2 0.2 2.5 1.5 2.6 2.6 0.2 1.4 1.5 1.8 3.2 2.5 0.9-1.4 0.5-2.9 2.6-3.7 0.2-0.1 0.3-0.4 0.3-0.4-3.1-2.2 1.2-2.2 2.3-3.3-3.1-1.8-4-4.3-3.7-7-1.5-0.3-3.1-0.4-4.5 0-1.7 0.6-2.2-0.5-2.9-1 0.6-0.5 0.8-1.1 2.2-1.3 7.6-0.9 15.2-1.7 22.9-2 20-0.7 39.9-0.9 59.9-1 11.9-0.1 23.8 0.4 35.6 1.1 3.6 0.2 7.1-0.9 10.7-0.5 7.9 0.9 15.8 0.3 23.8 0.5 7.3 0.1 14.4-0.6 21.7-0.1 12.2 0.9 24.4 0.3 36.7 0.6 9.4 0.3 18.9 0.4 28.2 1 11.9 0.7 23.8 1.3 35.6 2 11.1 0.6 22.4 0.5 33.3 2 7.1 1 14.4 1.1 21.3 2.4 4 0.7 8.2 1.6 12.4 1.9 2.2 0.2 0.9 1 1.5 1.5-4-0.8-8-0.8-12.1-1.4-4.3-0.7-8.5-1-12.8 0.4-2.9 1-6.3 0.2-9.3-0.1-10.2-1.1-20.6-1.6-30.8-2.4-12.1-0.9-24.3-1.4-36.4-2.1-9.9-0.6-20-0.5-29.9-1-11.4-0.6-22.7 0-34.2-0.5-6.3-0.3-12.3-0.3-18.5-0.4-4.2-0.1-8.4 1.3-12.8 0.3 0.6 0.2 1.2 0.7 1.9 0.7 10.5 0 20.9 1.9 31.6 1.7 6.5-0.1 13.1 0.2 19.8 0.8 3.2 0.3 6.3-0.4 9.7-0.1 7.6 0.7 15.5 0.5 23 0.8 12.4 0.5 24.7 0.4 37.1 1.1 13.3 0.7 26.8 2.1 39.9 4.1 6.2 0.9 12.7 1.5 19.2 1.7 0.6 0 1.1 0.1 1.5 0.5-4.6 0.1-9.3 0-13.9-0.5-0.6 1.1 1.4 0.9 1.5 1.9-9.7 1.6-19.6-1.4-29.4-0.1 2.2 1.4 5.1 1 7.4 1 7.3 0.1 14.1 1.3 21.2 1.9 2.8 0.3 5.9 0 8.5 0.8 1.5 0.5 4.6-1.1 4.9 1.3 4-0.7 7.3 1.5 11.1 1.2 4-0.3 7.7 0.6 11.6 1.1 0.8 0.1 2.2 0.3 2.3 1.1 0.2 1-1.1 1.2-2 1.5-3.4 1-6.7-0.4-10.1-0.4-0.9 0-2-0.2-2.9-0.2-9.4 0.1-18.8-1.3-28.3-1.8-6-0.4-12.1-0.9-18.1-1.3 0 0.2 0 0.4-0.2 0.6 6.1 0.5 12.1 1.4 18.3 0.7z"
                            />
                          </svg>
                        </span>
                      </span>
                    </h1>
                    <p style={{ fontWeight: '500' }} className="my-3 fs-5 text-dark description-title responsive-description-title" >
                      Cutting-Edge Tech Education Solutions With <br /> Customized Courses For Learners Everywhere
                    </p>
                    {/* <p className="my-3 fs-6 text-dark description-title responsive-description-title text-bold" ></p> */}

                  </div>
                  <div className="col-lg-7 col-xl-6 ml-4 text-center position-relative">
                    <div className="position-relative ms-7">
                      {/* <img className='home-img d-none d-md-block d-xl-block' src="/assets/images/school-girl.png" alt="" /> */}
                    </div>
                  </div>
                </div>
              </div>

            </section>
            <div className="d-flex flex-columnm text-dark justify-content-center mt-5 mb-4">
              <div class='col-10 text-center px-7'>
                <p style={{ fontFamily: 'Roboto' }}>
                  Q Academy is an Edtech company that specializes in providing innovative and
                  technology-driven solutions for education, corporate training, and skill development.
                  We are a subsidiary company of the established M Square Media Group. MSM group has been at the forefront of making international education accessible to students everywhere. Q Academy was incorporated in 2015 in British Columbia, Canada for working professionals to transcend geographical boundaries.

                </p>
                <p className="mt-1" style={{ textAlign: 'center' }}>Q Academy's customizable courses are led by stalwarts with great experience
                  and professional skills. The institution provides working professionals the right
                  education tools to upskill and to prepare them for success. Q Academy's commitment to
                  tech based education includes the use of LMS tools, boot camps, short-term specialty
                  courses, and certificate and diploma programs. The platform offers a flexible, accessible,
                  and interactive learning experience for learners.</p>
              </div>
            </div>


            {/* <hr style={{ color:'#000',fontSize:'10px'}} /> */}
            <div style={{ border: '1px solid #59595c', }}></div>

            <section className="pb-20 pt-0 pt-lg-5 d-flex flex-column justify-content-center align-items-center" >

              <div class=" " style={{ maxWidth: "1140px", }}>
                <div class="row ml-2" className='d-flex flex-row flex-wrap align-item-center' >
                  <div class="col position-relative" >
                    <img src={eyeQ} className='individualImg' class="img-fluid rounded-start" alt="..." style={{
                      marginLeft: '87px',
                      marginTop: '39px',
                      width: '60%',
                      height: '60%',
                      objectFit: 'contain'
                    }} />

                  </div>

                  <div class="col-md-8">
                    <div class="card-body " style={{ marginLeft: '2rem' }}>
                      <h5 style={{ color: "#0F75BC", }}></h5>
                      <h4 class="" style={{ fontWeight: '500', fontSize: '25px', textDecoration: "underline", paddingBottom: "15px", textDecorationColor: "#B1E0F4", textDecorationThickness: "6px", textUnderlineOffset: "10px", color: "rgba(5, 41, 93, 1)" }}>OUR VISION</h4>
                      <p class="text-dark fs-6" style={{ lineHeight: '30px' }}>
                        Our vision is to become the global leader in technology-based learning, revolutionizing the way
                        education is delivered and accessed worldwide. We are committed to empowering learners of all
                        ages and backgrounds through innovative and eﬀective educational tools, enabling them to
                        unlock their full potential.</p>

                    </div>
                  </div>
                </div>


                <div class="row" className='d-flex flex-row ' style={{ marginTop: "3rem" }}>

                  <div class="col-md-8">
                    <div class="card-body">
                      <h5 style={{ color: "#0F75BC", }}></h5>
                      <h4 class="" style={{ fontWeight: '500', fontSize: '25px', textDecoration: "underline", paddingBottom: "15px", textDecorationColor: "#B1E0F4", textDecorationThickness: "6px", textUnderlineOffset: "10px", color: "rgba(5, 41, 93, 1)" }}>OUR MISSION</h4>
                      <p class="text-dark fs-6" style={{ lineHeight: '30px' }}>Our mission is to create an engaging, interactive, and personalized online learning platform that
                        caters to the unique needs of every learner. We believe that education is a lifelong journey, and
                        our platform is designed to facilitate that journey by oﬀering a range of courses and learning
                        resources. Our constant endeavor is to empower individuals with knowledge &amp; skills that enable
                        them to thrive in a constantly evolving world.
                      </p>

                    </div>

                  </div>
                  <div class="col position-relative" style={{ width: "540px", }}>
                    <img src={arrowImg} className='individualImg' class="img-fluid rounded-start" alt="..." style={{
                      marginLeft: '101px',
                      marginTop: '40px',
                      width: '60%',
                      height: '60%',
                      objectFit: 'contain'
                    }} />

                  </div>
                </div>
              </div>
            </section>

            {/* <section className="partners-section" data-aos="fade-left" style={{ height: "320px", backgroundColor: "#F6F6F6" }}>
            <div className="col-lg-8 mx-auto text-center mb-4">
              <h5 className="" style={{ fontSize: '20px', letterSpacing: '1px', color:'rgba(26, 64, 119, 0.97)', fontFamily: "Roboto" }}>
                Some of the leading <a style={{color:'rgba(26, 64, 119, 0.97)',fontWeight:'bolder',fontSize:'23px'}} className='text-underline-hover'>
                  Companies</a> and <a style={{color:'rgba(26, 64, 119, 0.97)',fontWeight:'bolder',fontSize:'23px'}} className='text-underline-hover'>
                  Universities</a> with which we collaborated </h5>
            </div>
            <div id="carouselExampleControls" class="carousel slide d-flex position-relative justify-content-around" data-bs-ride="carousel">
              <button class="carousel-control-prev active align-items-center img-container justify-content-center position-absolute  ml-102 fs-1 " type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev" style={{ marginLeft: "102px", }}>
                <span class="carousel-control-prev-icon Carauselshadow" aria-hidden="true" style={{ height: "90px", width: "100px", color: "#ffffff", }}></span>
                <span class="visually-hidden">Previous</span>
              </button>
    
              <div class="h-100 overflow-hidden" style={{
              width:'60%'}}>
                <center>
                  <div class="align-items-center img-container justify-content-center align-self-sm-stretch flex-sm-fill">
                    <div class="carousel-item active ">
    
                      <img
                        style={imageSize}
                        src="/assets/images/newPartnerlogo/image1.png"
                        alt="Logo 3"
                      />
                      <img
                        style={imageSize}
                        src="/assets/images/newPartnerlogo/image2.jpeg"
                        alt="Logo 5"
                      />
                      <img
                        style={{ height: "120px", width: "135px" }}
                        src="/assets/images/newPartnerlogo/image3.jpeg"
                        alt="Logo 1"
                      />
                      <img
                        style={imageSize}
                        src="/assets/images/newPartnerlogo/image4.png"
                        alt="Logo 6"
                      />
                      <img
                        style={imageSize}
                        src="/assets/images/newPartnerlogo/image5.png"
                        alt="Logo 7"
                      />
                    </div>
                    <div class="carousel-item">
                      <img
                        style={imageSize}
                        src="/assets/images/newPartnerlogo/image6.png"
                        alt="Logo 5"
                      />
                      <img
                        style={imageSize}
                        src="/assets/images/newPartnerlogo/image7.png"
                        alt="Logo 6"
                      />    
                      <img
                        style={imageSize}
                        src="/assets/images/newPartnerlogo/image8.jpg"
                        alt="Logo 7"
                      />
                      <img
                        style={imageSize}
                        src="/assets/images/newPartnerlogo/image9.png"
                        alt="Logo 7"
                      />
                      <img className=""
                        style={imageSize}
                        src="/assets/images/newPartnerlogo/image10.png"
                        alt="Logo 7"
                      />
    
                    </div>
                    <div class="carousel-item">
                      <img
                        style={imageSize}
                        src="/assets/images/newPartnerlogo/image11.png"
                        alt="Logo 5"
                      />
                      <img
                        style={imageSize}
                        src="/assets/images/newPartnerlogo/image12.png"
                        alt="Logo 6"
                      />    
                      <img
                        style={imageSize}
                        src="/assets/images/newPartnerlogo/image13.png"
                        alt="Logo 7"
                      />
                      <img
                        style={imageSize}
                        src="/assets/images/newPartnerlogo/image14.jpeg"
                        alt="Logo 7"
                      />
                      <img className=""
                        style={imageSize}
                        src="/assets/images/newPartnerlogo/image17.jpeg"
                        alt="Logo 7"
                      />
    
                    </div>
                    <div class="carousel-item">
                      <img
                        style={imageSize}
                        src="/assets/images/newPartnerlogo/image19.png"
                        alt="Logo 5"
                      />
                      <img
                        style={imageSize}
                        src="/assets/images/newPartnerlogo/image22.png"
                        alt="Logo 6"
                      />    
                      <img
                        style={imageSize}
                        src="/assets/images/newPartnerlogo/image24.jpeg"
                        alt="Logo 7"
                      />
                      <img
                        style={imageSize}
                        src="/assets/images/newPartnerlogo/image25.png"
                        alt="Logo 7"
                      />
                      <img className=""
                        style={imageSize}
                        src="/assets/images/newPartnerlogo/image29.png"
                        alt="Logo 7"
                      />
    
                    </div>

                  </div>
                </center>
              </div>
    
              <button class="carousel-control-next active fs-1 align-items-center img-container justify-content-center position-absolute margin-right-102" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next" style={{ marginRight: "102px", }}>
                <span class="carousel-control-next-icon Carauselshadow" aria-hidden="true" style={{ height: "90px", width: "100px", color: "#000", textShadow: "12px 12px 5px red" }}></span>
                <span class=""><i class="far fa-angle-right fa-lg"></i></span>
              </button>
            </div>
            </section> */}
            <PartnerView dens={true} />

            <div
              className="text-center mt-5"
            >
              <h3 style={{ color: '#0F75BC' }}>Success Stories from Learners</h3>
              <p>Stories from those that have completed Professional Certificates</p>

              <Feedbackspearte />
            </div>

            <section className="" style={{ backgroundColor: '#EDF8FC' }}>

              <div class="container d-flex justify-content-around">

                <div class="row">
                  <div class="col-sm-4 ">
                    <div class="" style={{}}>
                      <h2
                        style={{ color: '#0F75BC', borderBottom: "5px solid rgba(177, 224, 244, 1)", width: "10rem" }}
                      >Our Story</h2>
                      <img src={osimg} class="" style={{ height: "250px", width: "250px", objectFit: 'contain' }} alt="..." />
                    </div>
                  </div>
                  <div class="col-sm-8">

                    <h5 style={{ lineHeight: "2rem", fontFamily: 'Roboto', marginBottom: '10px', fontSize: '18px' }}>Empowering the learners by equipping them with Futuristic art of technology across Industries!</h5>
                    <p class="text-dark" style={{ lineHeight: "1.5rem", fontFamily: 'Roboto' }}>Q Academy is a leading Tech-Based educational platform that delivers inspiring, industry-specific content to learning professionals. We aim to transform everyone's life through learning. We provide intensive Hybrid online training in a broad range of courses that includes coding and web development, Microsoft, computer fundamentals, graphic design, and other digital programs fit for ages 17 to 60. We also focus to provide in-demand skills for today's working professionals.</p>
                    <h5 style={{ lineHeight: "2rem", fontFamily: 'Roboto' }}>Q Academy is Strategic partners to AWS, NASSCOM & IIT Guwahati and affiliated partners of Electronics Sector Skill Council (ESSCI). We are also in the process of getting into partnership with NSDC, Govt. Of India and various state specific State Skill Development Mission (SSDM).</h5>
                  </div>
                </div>
              </div>
            </section>
          </section>}
        {isTablet &&
          <section class="">
            <section className="position-relative element-style overflow-hidden pt-5 AboutBanner" >
              <div className="container"  >
                <div className="row align-items-center ">
                  <div className="col-lg-5 col-xl-6 position-relative z-index-1 text-lg-start mt-5 p-5" style={{ marginLeft: '1rem' }}>

                    <h3 className="">
                      About Us
                      <span className="position-relative">
                        &nbsp;
                        {/* SVG START */}
                        <span className="position-absolute translate-middle ms-3 z-index-n1 d-none">
                          <svg
                            width="300px"
                            height="62.1px"
                            enableBackground="new 0 0 366 62.1"
                            viewBox="0 0 366 62.1"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              className="fill-warning"
                              d="m322.5 25.3c0 1.4 2.9 0.8 3.1 1.6 0.8 1.1-1.1 1.3-0.6 2.4 13.3 0.9 26.9 1.7 40.2 4-2.5 0.7-4.9 1.6-7.3 1.1-4-0.9-8.2-1-12.2-1.2-8.5-0.5-16.9-1.9-25.5-1.7h-3.1c2.6 0.6 4.8 0.4 5.7 2.2-7.3 0.4-14.1-0.8-21.2-1.1-0.2 0.6-0.5 1.2-0.8 1.8 21.3 0.7 42.5 1.6 64.3 4.6-4.2 1.6-7.7 1-10.8 0.8-6.8-0.5-13.5-1.3-20.3-1.9-0.9-0.1-2.3-0.1-2.9 0.2-2.2 1.6-4.3 0.6-7 0.4 1.4-1 2.5 0.5 3.9-0.8-5.6-1-10.7 0.6-15.9 0s-10.5-0.6-16.6-0.8c2 1.6 4.6 1.3 6.2 1.4 4.9 0 9.9 0.8 14.8 0.7 5.3-0.1 10.4 0.5 15.5 0.9 3.2 0.3 6.7-0.1 9.9-0.4 1.1-0.1 0.5 0.3 0.6 0.6 0.5 0.9 2.2 0.8 3.6 0.8 5.1-0.1 10.1 0.6 14.8 1.5 0.8 0.1 1.5 0 1.7 0.7 0 0.7-0.8 0.6-1.5 0.8-3.9 1.2-7.4-0.2-11.1-0.2-2 0-4.3-1.5-6 0.5-0.3 0.4-1.4 0.1-2.2-0.1-4.5-0.8-9.1-0.5-13.8-1.5-2.3-0.5-5.6 0.1-8.4 0.5-4 0.5-8-0.7-12.1-0.9-3.4-0.2-7.1-0.5-10.5-0.7-7.1-0.3-14.2-1.2-22.3-0.4 4.9 1.1 9.4 1.2 13.8 1.2 9.7 0 19.2 2.3 28.9 1.6 7.3 3.2 15.9 1.5 23.8 2.9 4.9 0.8 10.1 0.8 15.2 1.2 0.5 0 0.8 0.3 1.1 0.9-20-2.1-40.2-1.4-60.8-3 4.9 2.1 10.8-0.3 15.3 2.7-8 1.9-15.8-0.9-23.5-0.1 2.8 1.4 7.1 1.1 9.3 3.3 0.5 0.5 0.2 1.1-1.2 1.3 2.3 1 3.4-2.1 5.7-0.4 0.2-0.6 0.2-1 0.3-1.5 0.8-0.3 2 0.8 1.5 1.5-0.2 0.1 0 0.3 0 0.5 18.7 0.4 37.3 1.7 56.2 3.6-1.7 1.1-2.8 1.2-4.2 1.1-7.1-0.5-14.1-0.9-21.2-1.4-3.1-0.2-6.3-0.4-9.4-0.4-7.6-0.2-15-0.7-22.4-1-9-0.4-17.9-0.1-26.9-0.1-1.2 0-2.9-0.4-3.9 1 14.8 0.3 29.7 0.6 44.4 1.1 14.8 0.6 29.9 1.3 44.2 4.2-4.3 1-8.8 0.9-13 0.5-5.3-0.5-10.5-1.1-15.8-1.2-11.4-0.3-22.9-0.9-34.3-1.2-17.6-0.4-35.4-0.3-53.1-0.4-10.8-0.1-21.7-0.2-32.5 0-17.8 0.4-35.7 0.2-53.5 0.5-13.1 0.3-26.3 0.1-39.4 0.5-11.1 0.3-22.4 0.6-33.6 1-13.1 0.6-26.1 0.2-39.3 0.4-3.9 0.1-7.6 0.2-11.8-0.2 0.9-1.2 2.3-1.3 3.9-1.3 8.4 0.2 16.6-0.4 24.9-0.9 3.9-0.2 7.9-0.4 11.9 0.2 2.5 0.4 5.3-0.3 8-0.4 7.3-0.4 14.7-0.7 22-0.9 11.9-0.5 23.7-1.2 35.6-0.8 7.7 0.2 15.3-0.6 22.9-0.1 2.3 0.2 4.3-0.5 6.5-1h-17.6c-9.6 0-19-0.1-28.6 0-8 0.1-16.1 0.3-24 0.8-2.6 0.2-5.4 0.1-8.2 0.1-10.1 0.3-20.1 0.6-30.2 0.5-5.4 0-10.7-0.1-15.9 0.6-2.3 0.3-4-1.3-6.5-0.6 0.2 0.4 0.5 0.9 0.6 1.5-1.9 0-4 0.4-4.9-0.1-4.2-2.2-9.4-1.5-14.1-2.3-1.7-0.3-3.7-0.1-4.3-1.5-0.5-1.3 1.9-1.5 2.6-2.6-4.2-1.4-4.6-5-8.5-7.2-1.5 0.2-0.9 2.8-4.2 1.3 0.3 2.4 4.5 3.9 2.8 6.4-2.3 0.3-3.2-0.8-4.2-1.7-2.5-4-5.1-8.4-5.1-12.7 0.2-6.8 0.2-13.8 3.6-20.4 0.3-0.5 0.3-1 0.8-1.4 0.9-0.9 1.2-2.4 3.6-2.1 2.2 0.2 2.5 1.5 2.6 2.6 0.2 1.4 1.5 1.8 3.2 2.5 0.9-1.4 0.5-2.9 2.6-3.7 0.2-0.1 0.3-0.4 0.3-0.4-3.1-2.2 1.2-2.2 2.3-3.3-3.1-1.8-4-4.3-3.7-7-1.5-0.3-3.1-0.4-4.5 0-1.7 0.6-2.2-0.5-2.9-1 0.6-0.5 0.8-1.1 2.2-1.3 7.6-0.9 15.2-1.7 22.9-2 20-0.7 39.9-0.9 59.9-1 11.9-0.1 23.8 0.4 35.6 1.1 3.6 0.2 7.1-0.9 10.7-0.5 7.9 0.9 15.8 0.3 23.8 0.5 7.3 0.1 14.4-0.6 21.7-0.1 12.2 0.9 24.4 0.3 36.7 0.6 9.4 0.3 18.9 0.4 28.2 1 11.9 0.7 23.8 1.3 35.6 2 11.1 0.6 22.4 0.5 33.3 2 7.1 1 14.4 1.1 21.3 2.4 4 0.7 8.2 1.6 12.4 1.9 2.2 0.2 0.9 1 1.5 1.5-4-0.8-8-0.8-12.1-1.4-4.3-0.7-8.5-1-12.8 0.4-2.9 1-6.3 0.2-9.3-0.1-10.2-1.1-20.6-1.6-30.8-2.4-12.1-0.9-24.3-1.4-36.4-2.1-9.9-0.6-20-0.5-29.9-1-11.4-0.6-22.7 0-34.2-0.5-6.3-0.3-12.3-0.3-18.5-0.4-4.2-0.1-8.4 1.3-12.8 0.3 0.6 0.2 1.2 0.7 1.9 0.7 10.5 0 20.9 1.9 31.6 1.7 6.5-0.1 13.1 0.2 19.8 0.8 3.2 0.3 6.3-0.4 9.7-0.1 7.6 0.7 15.5 0.5 23 0.8 12.4 0.5 24.7 0.4 37.1 1.1 13.3 0.7 26.8 2.1 39.9 4.1 6.2 0.9 12.7 1.5 19.2 1.7 0.6 0 1.1 0.1 1.5 0.5-4.6 0.1-9.3 0-13.9-0.5-0.6 1.1 1.4 0.9 1.5 1.9-9.7 1.6-19.6-1.4-29.4-0.1 2.2 1.4 5.1 1 7.4 1 7.3 0.1 14.1 1.3 21.2 1.9 2.8 0.3 5.9 0 8.5 0.8 1.5 0.5 4.6-1.1 4.9 1.3 4-0.7 7.3 1.5 11.1 1.2 4-0.3 7.7 0.6 11.6 1.1 0.8 0.1 2.2 0.3 2.3 1.1 0.2 1-1.1 1.2-2 1.5-3.4 1-6.7-0.4-10.1-0.4-0.9 0-2-0.2-2.9-0.2-9.4 0.1-18.8-1.3-28.3-1.8-6-0.4-12.1-0.9-18.1-1.3 0 0.2 0 0.4-0.2 0.6 6.1 0.5 12.1 1.4 18.3 0.7z"
                            />
                          </svg>
                        </span>
                      </span>
                    </h3>




                    <p className="my-3 text-dark description-title responsive-description-title" >Cutting-Edge Tech Education Solutions With Customized Courses For Learners Everywhere</p>

                  </div>
                  <div className="col-lg-7 col-xl-6 ml-4 text-center position-relative">
                    <div className="position-relative ms-7">
                      {/* <img className='home-img d-none d-md-block d-xl-block' src="/assets/images/school-girl.png" alt="" /> */}
                    </div>
                  </div>
                </div>
              </div>

            </section>
            <div className="d-flex flex-columnm justify-content-center text-dark" >
              <div class='col p-3' style={{ textAlign: 'justify' }}>
                <p>
                  Q Academy is an Edtech company that specializes in providing innovative and technology-driven solutions for education, corporate training, and skill development. We are a subsidiary company of the established M Square Media Group. MSM group has been at the forefront of making international education accessible to students everywhere. Q Academy was incorporated in 2015 in British Columbia, Canada for working professionals to transcend geographical boundaries.

                </p>
                <p> Q Academy's customizable courses are led by stalwarts with great experience and professional skills. The institution provides working professionals the right education tools to upskill and to prepare them for success. Q Academy's commitment to tech based education includes the use of LMS tools, boot camps, short-term specialty courses, and certificate and diploma programs. The platform offers a flexible, accessible, and interactive learning experience for learners.</p>
              </div>
            </div>


            <hr style={{ fontSize: 'bold' }} />

            <section className="d-flex flex-column justify-content-center align-items-center pt-0 pb-0" >

              {/* <div class="col position-relative mb-5" >
                <img src={eyeQ} className='individualImg' class="img-fluid rounded-start" alt="..." style={{
                    width: '60%',
                    height: '60%',
                    objectFit: 'contain'
                }} />

              </div>*/}

              <div class="card-body p-3" style={{ textAlign: 'justify' }}>

                <h4 class="" style={{ fontWeight: '500', fontSize: '25px', textDecoration: "underline", paddingBottom: "15px", textDecorationColor: "#B1E0F4", textDecorationThickness: "6px", textUnderlineOffset: "10px", color: "rgba(5, 41, 93, 1)" }}>OUR VISION</h4>
                <p class="text-dark" style={{ lineHeight: '30px' }}>
                  Our vision is to become the global leader in technology-based learning, revolutionizing the way
                  education is delivered and accessed worldwide. We are committed to empowering learners of all
                  ages and backgrounds through innovative and eﬀective educational tools, enabling them to
                  unlock their full potential.</p>

              </div>



              <div class="card-body p-3" style={{ textAlign: 'justify' }}>
                <h5 style={{ color: "#0F75BC", }}></h5>
                <h4 class="" style={{ textDecoration: "underline", fontWeight: '500', fontSize: '25px', paddingBottom: "15px", textDecorationColor: "#B1E0F4", textDecorationThickness: "6px", textUnderlineOffset: "10px", color: "rgba(5, 41, 93, 1)" }}>OUR MISSION</h4>
                <p class="text-dark fs-6" style={{ lineHeight: '30px' }}>Our mission is to create an engaging, interactive, and personalized online learning platform that
                  caters to the unique needs of every learner. We believe that education is a lifelong journey, and
                  our platform is designed to facilitate that journey by oﬀering a range of courses and learning
                  resources. Our constant endeavor is to empower individuals with knowledge &amp; skills that enable
                  them to thrive in a constantly evolving world.
                </p>

              </div>
              {/*
              <div class="col position-relative">
                <img src={arrowImg} className='individualImg' class="img-fluid rounded-start" alt="..." style={{
                  marginLeft: '101px',
                  margintop: '13px'
                }} />

              </div>*/}
            </section>

            <div
              className="text-center mt-2">
              <h3 style={{ color: '#0F75BC', padding: '0px 3px 0px 3px' }}>Success Stories from Learners</h3>
              <p style={{ padding: '0px 3px 0px 3px' }}>Stories from those that have completed Professional Certificates</p>

              <Feedbackspearte />
            </div>

            <section className="" style={{ backgroundColor: '#EDF8FC' }}>
              <div class="container d-flex justify-content-around">
                <div class="row">
                  <div class="col-sm-4 ">
                    <div class="d-flex flex-column " style={{}}>
                      <div class="d-flex justify-content-center">
                        <h2

                          style={{ color: '#0F75BC', borderBottom: "5px solid lightblue", width: "10rem" }}
                        >Our Story</h2>
                      </div>
                      <img class="justify-content-center" src={osimg} style={{ height: "250px", width: "300px", objectFit: 'fill' }} alt="..." />
                    </div>
                  </div>
                  <div class="col-sm-8" style={{ textAlign: 'justify' }}>
                    <h4 style={{ lineHeight: "2rem", fontFamily: 'Roboto', marginBottom: '1px' }}>Empowering the learners by equipping them with Futuristic art of technology across Industries!</h4>
                    <p class="text-dark" style={{ lineHeight: "1.5rem", fontFamily: 'Roboto' }}>Q Academy is a leading Tech-Based educational platform that delivers inspiring, industry-specific content to learning professionals. We aim to transform everyone's life through learning. We provide intensive Hybrid online training in a broad range of courses that includes coding and web development, Microsoft, computer fundamentals, graphic design, and other digital programs fit for ages 17 to 60. We also focus to provide in-demand skills for today's working professionals.</p>
                    <h5 style={{ lineHeight: "2rem", fontFamily: 'Roboto' }}>Q Academy is Strategic partners to AWS, NASSCOM & IIT Guwahati and affiliated partners of Electronics Sector Skill Council (ESSCI). We are also in the process of getting into partnership with NSDC, Govt. Of India and various state specific State Skill Development Mission (SSDM).</h5>
                  </div>
                </div>
              </div>
            </section>
          </section>}

        {isMobile &&
          <section class="">
            <section className="position-relative element-style overflow-hidden pt-5 AboutBanner" >
              <div className="container"  >
                <div className="row align-items-center ">
                  <div className="col-lg-5 col-xl-6 position-relative z-index-1 text-lg-start mt-5 p-5" style={{ marginLeft: '1rem' }}>

                    <h3 className="">
                      About Us
                      <span className="position-relative">
                        &nbsp;
                        {/* SVG START */}
                        <span className="position-absolute translate-middle ms-3 z-index-n1 d-none">
                          <svg
                            width="300px"
                            height="62.1px"
                            enableBackground="new 0 0 366 62.1"
                            viewBox="0 0 366 62.1"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              className="fill-warning"
                              d="m322.5 25.3c0 1.4 2.9 0.8 3.1 1.6 0.8 1.1-1.1 1.3-0.6 2.4 13.3 0.9 26.9 1.7 40.2 4-2.5 0.7-4.9 1.6-7.3 1.1-4-0.9-8.2-1-12.2-1.2-8.5-0.5-16.9-1.9-25.5-1.7h-3.1c2.6 0.6 4.8 0.4 5.7 2.2-7.3 0.4-14.1-0.8-21.2-1.1-0.2 0.6-0.5 1.2-0.8 1.8 21.3 0.7 42.5 1.6 64.3 4.6-4.2 1.6-7.7 1-10.8 0.8-6.8-0.5-13.5-1.3-20.3-1.9-0.9-0.1-2.3-0.1-2.9 0.2-2.2 1.6-4.3 0.6-7 0.4 1.4-1 2.5 0.5 3.9-0.8-5.6-1-10.7 0.6-15.9 0s-10.5-0.6-16.6-0.8c2 1.6 4.6 1.3 6.2 1.4 4.9 0 9.9 0.8 14.8 0.7 5.3-0.1 10.4 0.5 15.5 0.9 3.2 0.3 6.7-0.1 9.9-0.4 1.1-0.1 0.5 0.3 0.6 0.6 0.5 0.9 2.2 0.8 3.6 0.8 5.1-0.1 10.1 0.6 14.8 1.5 0.8 0.1 1.5 0 1.7 0.7 0 0.7-0.8 0.6-1.5 0.8-3.9 1.2-7.4-0.2-11.1-0.2-2 0-4.3-1.5-6 0.5-0.3 0.4-1.4 0.1-2.2-0.1-4.5-0.8-9.1-0.5-13.8-1.5-2.3-0.5-5.6 0.1-8.4 0.5-4 0.5-8-0.7-12.1-0.9-3.4-0.2-7.1-0.5-10.5-0.7-7.1-0.3-14.2-1.2-22.3-0.4 4.9 1.1 9.4 1.2 13.8 1.2 9.7 0 19.2 2.3 28.9 1.6 7.3 3.2 15.9 1.5 23.8 2.9 4.9 0.8 10.1 0.8 15.2 1.2 0.5 0 0.8 0.3 1.1 0.9-20-2.1-40.2-1.4-60.8-3 4.9 2.1 10.8-0.3 15.3 2.7-8 1.9-15.8-0.9-23.5-0.1 2.8 1.4 7.1 1.1 9.3 3.3 0.5 0.5 0.2 1.1-1.2 1.3 2.3 1 3.4-2.1 5.7-0.4 0.2-0.6 0.2-1 0.3-1.5 0.8-0.3 2 0.8 1.5 1.5-0.2 0.1 0 0.3 0 0.5 18.7 0.4 37.3 1.7 56.2 3.6-1.7 1.1-2.8 1.2-4.2 1.1-7.1-0.5-14.1-0.9-21.2-1.4-3.1-0.2-6.3-0.4-9.4-0.4-7.6-0.2-15-0.7-22.4-1-9-0.4-17.9-0.1-26.9-0.1-1.2 0-2.9-0.4-3.9 1 14.8 0.3 29.7 0.6 44.4 1.1 14.8 0.6 29.9 1.3 44.2 4.2-4.3 1-8.8 0.9-13 0.5-5.3-0.5-10.5-1.1-15.8-1.2-11.4-0.3-22.9-0.9-34.3-1.2-17.6-0.4-35.4-0.3-53.1-0.4-10.8-0.1-21.7-0.2-32.5 0-17.8 0.4-35.7 0.2-53.5 0.5-13.1 0.3-26.3 0.1-39.4 0.5-11.1 0.3-22.4 0.6-33.6 1-13.1 0.6-26.1 0.2-39.3 0.4-3.9 0.1-7.6 0.2-11.8-0.2 0.9-1.2 2.3-1.3 3.9-1.3 8.4 0.2 16.6-0.4 24.9-0.9 3.9-0.2 7.9-0.4 11.9 0.2 2.5 0.4 5.3-0.3 8-0.4 7.3-0.4 14.7-0.7 22-0.9 11.9-0.5 23.7-1.2 35.6-0.8 7.7 0.2 15.3-0.6 22.9-0.1 2.3 0.2 4.3-0.5 6.5-1h-17.6c-9.6 0-19-0.1-28.6 0-8 0.1-16.1 0.3-24 0.8-2.6 0.2-5.4 0.1-8.2 0.1-10.1 0.3-20.1 0.6-30.2 0.5-5.4 0-10.7-0.1-15.9 0.6-2.3 0.3-4-1.3-6.5-0.6 0.2 0.4 0.5 0.9 0.6 1.5-1.9 0-4 0.4-4.9-0.1-4.2-2.2-9.4-1.5-14.1-2.3-1.7-0.3-3.7-0.1-4.3-1.5-0.5-1.3 1.9-1.5 2.6-2.6-4.2-1.4-4.6-5-8.5-7.2-1.5 0.2-0.9 2.8-4.2 1.3 0.3 2.4 4.5 3.9 2.8 6.4-2.3 0.3-3.2-0.8-4.2-1.7-2.5-4-5.1-8.4-5.1-12.7 0.2-6.8 0.2-13.8 3.6-20.4 0.3-0.5 0.3-1 0.8-1.4 0.9-0.9 1.2-2.4 3.6-2.1 2.2 0.2 2.5 1.5 2.6 2.6 0.2 1.4 1.5 1.8 3.2 2.5 0.9-1.4 0.5-2.9 2.6-3.7 0.2-0.1 0.3-0.4 0.3-0.4-3.1-2.2 1.2-2.2 2.3-3.3-3.1-1.8-4-4.3-3.7-7-1.5-0.3-3.1-0.4-4.5 0-1.7 0.6-2.2-0.5-2.9-1 0.6-0.5 0.8-1.1 2.2-1.3 7.6-0.9 15.2-1.7 22.9-2 20-0.7 39.9-0.9 59.9-1 11.9-0.1 23.8 0.4 35.6 1.1 3.6 0.2 7.1-0.9 10.7-0.5 7.9 0.9 15.8 0.3 23.8 0.5 7.3 0.1 14.4-0.6 21.7-0.1 12.2 0.9 24.4 0.3 36.7 0.6 9.4 0.3 18.9 0.4 28.2 1 11.9 0.7 23.8 1.3 35.6 2 11.1 0.6 22.4 0.5 33.3 2 7.1 1 14.4 1.1 21.3 2.4 4 0.7 8.2 1.6 12.4 1.9 2.2 0.2 0.9 1 1.5 1.5-4-0.8-8-0.8-12.1-1.4-4.3-0.7-8.5-1-12.8 0.4-2.9 1-6.3 0.2-9.3-0.1-10.2-1.1-20.6-1.6-30.8-2.4-12.1-0.9-24.3-1.4-36.4-2.1-9.9-0.6-20-0.5-29.9-1-11.4-0.6-22.7 0-34.2-0.5-6.3-0.3-12.3-0.3-18.5-0.4-4.2-0.1-8.4 1.3-12.8 0.3 0.6 0.2 1.2 0.7 1.9 0.7 10.5 0 20.9 1.9 31.6 1.7 6.5-0.1 13.1 0.2 19.8 0.8 3.2 0.3 6.3-0.4 9.7-0.1 7.6 0.7 15.5 0.5 23 0.8 12.4 0.5 24.7 0.4 37.1 1.1 13.3 0.7 26.8 2.1 39.9 4.1 6.2 0.9 12.7 1.5 19.2 1.7 0.6 0 1.1 0.1 1.5 0.5-4.6 0.1-9.3 0-13.9-0.5-0.6 1.1 1.4 0.9 1.5 1.9-9.7 1.6-19.6-1.4-29.4-0.1 2.2 1.4 5.1 1 7.4 1 7.3 0.1 14.1 1.3 21.2 1.9 2.8 0.3 5.9 0 8.5 0.8 1.5 0.5 4.6-1.1 4.9 1.3 4-0.7 7.3 1.5 11.1 1.2 4-0.3 7.7 0.6 11.6 1.1 0.8 0.1 2.2 0.3 2.3 1.1 0.2 1-1.1 1.2-2 1.5-3.4 1-6.7-0.4-10.1-0.4-0.9 0-2-0.2-2.9-0.2-9.4 0.1-18.8-1.3-28.3-1.8-6-0.4-12.1-0.9-18.1-1.3 0 0.2 0 0.4-0.2 0.6 6.1 0.5 12.1 1.4 18.3 0.7z"
                            />
                          </svg>
                        </span>
                      </span>
                    </h3>




                    <p className="my-3 text-dark description-title responsive-description-title" >Cutting-Edge Tech Education Solutions With Customized Courses For Learners Everywhere</p>

                  </div>
                  <div className="col-lg-7 col-xl-6 ml-4 text-center position-relative">
                    <div className="position-relative ms-7">
                      {/* <img className='home-img d-none d-md-block d-xl-block' src="/assets/images/school-girl.png" alt="" /> */}
                    </div>
                  </div>
                </div>
              </div>

            </section>
            <div className="d-flex flex-columnm justify-content-center text-dark" >
              <div class='col p-3' style={{ textAlign: 'justify' }}>
                <p>
                  Q Academy is an Edtech company that specializes in providing innovative and technology-driven solutions for education, corporate training, and skill development. We are a subsidiary company of the established M Square Media Group. MSM group has been at the forefront of making international education accessible to students everywhere. Q Academy was incorporated in 2015 in British Columbia, Canada for working professionals to transcend geographical boundaries.

                </p>
                <p> Q Academy's customizable courses are led by stalwarts with great experience and professional skills. The institution provides working professionals the right education tools to upskill and to prepare them for success. Q Academy's commitment to tech based education includes the use of LMS tools, boot camps, short-term specialty courses, and certificate and diploma programs. The platform offers a flexible, accessible, and interactive learning experience for learners.</p>
              </div>
            </div>


            <hr style={{ fontSize: 'bold' }} />

            <section className="d-flex flex-column justify-content-center align-items-center pt-0 pb-0" >

              {/* <div class="col position-relative mb-5" >
                <img src={eyeQ} className='individualImg' class="img-fluid rounded-start" alt="..." style={{
                    width: '60%',
                    height: '60%',
                    objectFit: 'contain'
                }} />

              </div>*/}

              <div class="card-body p-3" style={{ textAlign: 'justify' }}>

                <h4 class="" style={{ fontWeight: '500', fontSize: '25px', textDecoration: "underline", paddingBottom: "15px", textDecorationColor: "#B1E0F4", textDecorationThickness: "6px", textUnderlineOffset: "10px", color: "rgba(5, 41, 93, 1)" }}>OUR VISION</h4>
                <p class="text-dark" style={{ lineHeight: '30px' }}>
                  Our vision is to become the global leader in technology-based learning, revolutionizing the way
                  education is delivered and accessed worldwide. We are committed to empowering learners of all
                  ages and backgrounds through innovative and eﬀective educational tools, enabling them to
                  unlock their full potential.</p>

              </div>



              <div class="card-body p-3" style={{ textAlign: 'justify' }}>
                <h5 style={{ color: "#0F75BC", }}></h5>
                <h4 class="" style={{ textDecoration: "underline", fontWeight: '500', fontSize: '25px', paddingBottom: "15px", textDecorationColor: "#B1E0F4", textDecorationThickness: "6px", textUnderlineOffset: "10px", color: "rgba(5, 41, 93, 1)" }}>OUR MISSION</h4>
                <p class="text-dark fs-6" style={{ lineHeight: '30px' }}>Our mission is to create an engaging, interactive, and personalized online learning platform that
                  caters to the unique needs of every learner. We believe that education is a lifelong journey, and
                  our platform is designed to facilitate that journey by oﬀering a range of courses and learning
                  resources. Our constant endeavor is to empower individuals with knowledge &amp; skills that enable
                  them to thrive in a constantly evolving world.
                </p>

              </div>
              {/*
              <div class="col position-relative">
                <img src={arrowImg} className='individualImg' class="img-fluid rounded-start" alt="..." style={{
                  marginLeft: '101px',
                  margintop: '13px'
                }} />

              </div>*/}
            </section>



            <PartnerView dens={true} />


            <div
              className="text-center mt-2">
              <h3 style={{ color: '#0F75BC', padding: '0px 3px 0px 3px' }}>Success Stories from Learners</h3>
              <p style={{ padding: '0px 3px 0px 3px' }}>Stories from those that have completed Professional Certificates</p>

              <Feedbackspearte />
              {/* <FeedbackView /> */}
            </div>

            <OurStory />
          </section>}
      </main>
      <Footer />
    </div>
  );
}

export const OurStory = () => {
  return (
    <section className="" style={{ backgroundColor: '#EDF8FC' }}>
      <div class="container d-flex justify-content-around">
        <div class="row">
          <div class="col-sm-4 ">
            <div class="d-flex flex-column " style={{}}>
              <div class="d-flex justify-content-center">
                <h2

                  style={{ color: '#0F75BC', borderBottom: "5px solid lightblue", width: "10rem" }}
                >Our Story</h2>
              </div>
              <img class="justify-content-center" src={osimg} style={{ height: "250px", width: "300px", objectFit: 'fill' }} alt="..." />
            </div>
          </div>
          <div class="col-sm-8" style={{ textAlign: 'justify' }}>
            <h4 style={{ lineHeight: "2rem", fontFamily: 'Roboto', marginBottom: '1px' }}>Empowering the learners by equipping them with Futuristic art of technology across Industries!</h4>
            <p class="text-dark" style={{ lineHeight: "1.5rem", fontFamily: 'Roboto' }}>Q Academy is a leading Tech-Based educational platform that delivers inspiring, industry-specific content to learning professionals. We aim to transform everyone's life through learning. We provide intensive Hybrid online training in a broad range of courses that includes coding and web development, Microsoft, computer fundamentals, graphic design, and other digital programs fit for ages 17 to 60. We also focus to provide in-demand skills for today's working professionals.</p>
            <h5 style={{ lineHeight: "2rem", fontFamily: 'Roboto' }}>Q Academy is Strategic partners to AWS, NASSCOM & IIT Guwahati and affiliated partners of Electronics Sector Skill Council (ESSCI). We are also in the process of getting into partnership with NSDC, Govt. Of India and various state specific State Skill Development Mission (SSDM).</h5>
          </div>
        </div>
      </div>
    </section>
  )
}
